import { IObjectTree, IObjectTreeDataManager, IObjectTreeFolder } from "../PA.Core.IF.ObjectTree";
import { WB_TreeFolderRow } from "../PAdbSchemaRows";
import { ExecutionSerializer } from "../Basic/ExecutionSerializer";
import * as _ from "lodash";
import { PAdbContext } from "../PAdbContext";
import { esWB_Tree_Folder } from "../PAdbSchema";
import { ObjectTree } from "./ObjectTree";


export class ObjectTreeFolder implements IObjectTreeFolder {

    tree: ObjectTree;
    tfr: WB_TreeFolderRow;
    parent: IObjectTreeFolder;
    subFolders: ObjectTreeFolder[];
    qsSave: ExecutionSerializer


    constructor(tree: ObjectTree,
                treeFolderRow: WB_TreeFolderRow,
                parent?: IObjectTreeFolder)
    {
        this.tree = tree;
        this.tfr = treeFolderRow;
        this.parent = parent;
        this.subFolders = [];
        this.qsSave = new ExecutionSerializer(this, this.SaveQueue.bind(this),
            [{}], 1000, false)

        if(this.tfr.isActiveNew)
            this.Save()
    }

    get Tree(): IObjectTree {
        return this.tree;
    }

    get wbId(): number {
        return this.tfr.cif.WB_TREE_FOLDER_ID;
    }

    get Name(): string {
        return this.tfr.cif.FOLDER_NAME;
    }

    get ContentDataManager(): IObjectTreeDataManager {
        return undefined
    }

    get wbIdParent(): number {
        return this.tfr?.cif?.WB_TREE_FOLDER_ID_PRNT || 0
    }

    get Parent(): IObjectTreeFolder {
        return this.parent;
    }

    get SubFolders(): IObjectTreeFolder[] {
        return this.subFolders;
    }

    setParent(prnt: IObjectTreeFolder) {
        this.parent = prnt
        let wbId = prnt?.wbId || 0;
        if(wbId != this.tfr.cif.WB_TREE_FOLDER_ID_PRNT) {
            this.tfr.cif.WB_TREE_FOLDER_ID_PRNT = wbId;
            this.Save();
        }
    }

    setName(name: string) {
        if(name != this.tfr.cif.FOLDER_NAME){
            this.tfr.cif.FOLDER_NAME = name
            this.Save();
        }
    }

    addSubFolder(fldr: ObjectTreeFolder) {
        this.subFolders.push(fldr);
    }

    removeSubFolder(fldr: ObjectTreeFolder) {
        _.remove(this.subFolders, (a) => a.wbId == fldr.wbId);
    }

    get isActive(): boolean {
        return this.tfr.isActive
    }

    Delete() {
        if(this.tfr.isActive){
            this.tfr.markDeleted()
            this.qsSave.Run()
        }
    }

    private Save() {
        this.qsSave.Run()
    }

    private async SaveQueue(): Promise<void> {
        // dbContext.Save uses async lock
        if(this.tfr){
            let dbContext: PAdbContext = <PAdbContext> this.tfr.dataStore()
            await dbContext.Save(esWB_Tree_Folder, this.tfr)
            if(this.Tree)
                this.Tree.OnFoldersChanged.next({Tree:  this.Tree, Change: "Save"})
        }

    }


}
